<template>
  <div class="job-post">
    <div
      class="p-3 shadow-sm border bg-white my-3 projects-lists"
      v-if="status == 1 || status == 2 || status == 3"
    >
      <div class="row">
        <div class="col-6">
          <div class="kova-circle">{{setTitle}}</div>
          <p class="mt-2 font-weight-bolder text-left ml-2">{{setStatus}}</p>
        </div>
        <div class="col-6">
          <div class="row justify-content-end pr-2">
            <span class="id text-white px-2">ID: {{id}}</span>
            <a-icon class="ctrl-ellipsis font-weight-bolder" rotate="90" type="ellipsis" />
          </div>
        </div>
      </div>
      <div class>
        <h5 class="font-weight-bolder mx-1 text-left" v-html="title"></h5>
      </div>
    </div>
    <div class="p-3 shadow-sm border my-3 projects-lists kova-bg" v-if="status == 4">
      <div class="row">
        <div class="col-6">
          <div class="kova-circle" style="border: solid 2px #fff;">{{setTitle}}</div>
          <p class="mt-2 font-weight-bolder text-left ml-2 text-white">{{setStatus}}</p>
        </div>
        <div class="col-6">
          <div class="row justify-content-end pr-2">
            <span class="id text-white px-2">ID: {{id}}</span>
            <a-icon
              class="ctrl-ellipsis font-weight-bolder text-white"
              rotate="90"
              type="ellipsis"
            />
          </div>
        </div>
      </div>
      <div class>
        <h5 class="font-weight-bolder mx-1 text-left text-white" v-html="setDescription"></h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "job-post",
  props: {
    title: { type: String },
    status: { type: Number },
    id: { type: Number },
    text: { type: String }
  },
  data() {
    return {};
  },
  computed: {
    setTitle: function() {
      const title = this.title.split(" ");
      let computedTitle;
      if (title.length < 2) {
        computedTitle = title[0][0].toUpperCase() + title[0][1].toUpperCase();
      } else {
        computedTitle = title[0][0].toUpperCase() + title[1][0].toUpperCase();
      }
      return computedTitle;
    },
    setDescription: function() {
      let description = this.text;
      if (description.length < 35) {
        return description;
      }
      return this.text.slice(0, 35) + "...";
    },
    setStatus: function() {
      switch (this.status) {
        case 1:
          return "Hiring";
        case 2:
          return "Hiring";
        case 3:
          return "Closed";
        case 4:
          return "Ongoing";
        case 5:
          return "Archived";
        case 6:
          return "Completed";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
.projects-container {
  height: 530px;
  overflow-y: scroll;
}
.add-rounded {
  border-radius: 10px;
}

.kova-circle {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  background-color: #20409a;
  color: #fff;
  font-size: 25px;
  font-weight: bolder;
  line-height: 80px;
}
.id {
  height: 20px;
  background-color: #4bb38e;
  border-radius: 5px;
}
.ctrl-ellipsis {
  font-size: 20px;
  color: #4bb38e;
}
.projects-lists {
  width: 260px;
}

/* total width */

/* set button(top and bottom of the scrollbar) */
.scrollbar::-webkit-scrollbar-button {
  display: none;
}

@media screen and (min-width: 992px) and (max-width: 1325px) {
  .projects-lists {
    width: 300px;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .employer-name {
    font-size: 18px;
  }
  .img-height {
    width: 70px;
    height: 70px;
  }
  .projects-lists {
    width: 260px;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
}

@media screen and (max-width: 767px) {
}
</style>